import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock";

export default function Services() {
  return (
    <section className="relative border-t border-white/5 py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-display text-xs uppercase tracking-[0.3em] text-[#d4ff4e]"
        >
          (Services)
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display mt-6 max-w-3xl text-4xl font-medium leading-tight md:text-6xl"
        >
          What we build for you
        </motion.h2>

        <div className="mt-16 border-t border-white/10">
          {services.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-hover
              className="group grid grid-cols-12 items-center gap-4 border-b border-white/10 py-8 transition-colors hover:bg-white/[0.03]"
            >
              <div className="col-span-2 font-display text-sm text-[#8a8a86] md:col-span-1">{s.index}</div>
              <div className="col-span-8 md:col-span-4">
                <h3 className="font-display text-2xl font-medium text-white transition-transform duration-500 group-hover:translate-x-2 md:text-3xl">
                  {s.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="text-sm leading-relaxed text-[#9a9a96]">{s.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span key={t} className="rounded-full border border-white/10 px-3 py-1 text-xs text-[#c9c9c4]">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="col-span-2 flex justify-end md:col-span-2">
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white transition-all duration-500 group-hover:border-[#d4ff4e] group-hover:bg-[#d4ff4e] group-hover:text-black">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
